<ng-container *ngIf="steps$ | async as steps">
	<imv-ui-steps *ngIf="steps.length" [steps]="steps">
		<ng-container *ngFor="let step of steps; trackBy: trackByIndex"> </ng-container>
	</imv-ui-steps>
</ng-container>
